import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/tema_light/view_main.vue"),
    props: { uuidGaleria: "f67f73a9-f5e2-4b00-b94a-60af64985989" },
  },
  {
    path: "/jornada/:nombre_seo_participante",
    name: "ficha_jornada_participante",
    component: () => import("@/views/tema_light/view_ficha_participante.vue"),
  },

  {
    path: "/ganadores-anteriores",
    name: "ganadores-anteriores",
    component: () => import("@/views/tema_light/view_ganadores_anteriores.vue"),
  },

  {
    path: "/galerias-fotos",
    name: "galerias-fotos",
    component: () => import("@/views/tema_light/view_galerias_fotos.vue"),
    props: { uuid: "037e4180-ce89-4e24-b903-3b409aa0f172" },
  },

  {
    path: "/entrega-premios-2026",
    name: "entrega-premios-2026",
    component: () => import("@/views/tema_light/view_galerias_fotos.vue"),
    props: { uuid: "d44f8d80-7350-4a84-b89e-b684cc15f0f7" },
  },

  {
    path: "/patrocinadores",
    name: "patrocinadores",
    component: () => import("@/views/tema_light/view_patrocinadores.vue"),
  },

  {
    path: "/textos-legales",
    name: "",
    component: () => import("@/layouts/tema_light/textos_layout.vue"),
    children: [
      {
        path: "/textos-legales/:url_texto",
        name: "texto-legal",
        component: () => import("@/views/tema_light/view_texto_legal.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }

    return { top: 0 };
  },
});

export default router;
